import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Menu, Phone, Facebook, Youtube } from 'lucide-react';

const Header = () => {
  const handleCallNow = () => {
    window.location.href = 'tel:2487853734';
  };

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <img 
              src="https://d64gsuwffb70l.cloudfront.net/68529ada89b91746d63b58af_1750645386680_6144316a.jpg" 
              alt="Bridgeriver Advisors Logo" 
              className="h-24 w-auto"
            />
          </div>
          
          <nav className="hidden md:flex items-center space-x-8">
            <a href="/" className="text-gray-700 hover:text-slate-600 font-medium transition-colors">
              Home
            </a>
            <a href="/events" className="text-gray-700 hover:text-slate-600 font-medium transition-colors">
              Events
            </a>
            <a href="#services" className="text-gray-700 hover:text-slate-600 font-medium transition-colors">
              Services
            </a>
            <a href="#appearances" className="text-gray-700 hover:text-slate-600 font-medium transition-colors">
              TV Appearances
            </a>
            <a href="#contact" className="text-gray-700 hover:text-slate-600 font-medium transition-colors">
              Contact
            </a>
            
            {/* Social Media Icons */}
            <div className="flex items-center space-x-3 ml-4">
              <a href="https://www.facebook.com/Bridgeriver" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-slate-600 transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="https://www.youtube.com/@bridgeriveradvisors" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-slate-600 transition-colors">
                <Youtube className="w-5 h-5" />
              </a>
            </div>
          </nav>
          
          <div className="flex items-center space-x-4">
            <Button 
              className="hidden md:flex items-center space-x-2 bg-slate-600 hover:bg-slate-700 text-white font-semibold px-6 py-2 rounded-lg shadow-lg transition-all duration-200 hover:shadow-xl"
              onClick={handleCallNow}
            >
              <Phone className="w-4 h-4" />
              <span>Call Now</span>
            </Button>
            
            <Button variant="ghost" size="sm" className="md:hidden">
              <Menu className="w-5 h-5" />
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
